<template>
  <div v-if="isLoading" class="p-4 text-center">
    <span class="loading loading-spinner loading-lg text-base-content/60"></span>
  </div>
  <div v-else class="h-full flex flex-col">
    <div class="flex-1 px-4 pt-20">
      <div class="flex justify-center">
        <div class="relative">
          <div
            class="avatar placeholder"
            :class="
              authStore.user.status === 'working'
                ? 'avatar-online '
                : 'avatar-offline'
            "
          >
            <div
              class="bg-neutral text-neutral-content w-16 h-16 rounded-full place-content-center text-center"
            >
              <span v-if="authStore.user" class="text-xl font-bold">{{
                authStore.user.initials
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center mt-3 text-2xl font-semibold">
        {{ authStore.user.name }} {{ authStore.user.surname }}
      </div>
      <div class="text-center text-sm text-base-content/60">
        {{ roleTranslations[authStore.user.role] }}
      </div>
      <div class="text-center mt-6">
        {{ authStore.user.phone }}
      </div>
      <div class="text-center">
        {{ authStore.user.organization.name }}
      </div>
    </div>
    <div class="px-4 pt-2 pb-4">
      <button @click="handleLogout" class="btn w-full rounded-xl h-14">
        Atsijungti
      </button>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";

const router = useRouter();
// import DefaultIcon from "@/components/icons/DefaultIcon.vue";

const authStore = useAuthStore();
const isLoading = ref(true);

onMounted(async () => {
  try {
    isLoading.value = true;
    await authStore.fetchUser();
  } catch (error) {
    console.error("Failed to fetch user:", error);
  } finally {
    isLoading.value = false;
  }
});

const handleLogout = async () => {
  try {
    await authStore.logout();
    router.push("/login");
  } catch (error) {
    console.error("Logout failed:", error);
    // You might want to add error handling here
  }
};

const roleTranslations = {
  planner: "Planuotojas",
  admin: "Administratorius",
  driver: "Vairuotojas",
};
</script>
